"use strict";
// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// source: testapi/card-testapi-service.proto
//
// GitHub:
// https://github.com/search?q=repo%3Agetstep%2Fserver+path%3Aproto%2Ftestapi%2Fcard-testapi-service.proto&type=code
Object.defineProperty(exports, "__esModule", { value: true });
exports.CardTestApiServiceClient = exports.UpdateExpirationDateResponse = exports.UpdateExpirationDateRequest = exports.UpdateShippingResponse = exports.UpdateShippingRequest = void 0;
/* eslint-disable */
const rpc_1 = require("@getstep/proto-lib/rpc");
const issuer_card_1 = require("../card/issuer-card");
const card_details_1 = require("../common/card-details");
const date_1 = require("../common/date");
const protobufPackage = 'com.step.testapi.card.proto';
function createBaseUpdateShippingRequest() {
    return { cardId: '', status: card_details_1.CardShippingStatus.INVALID_CARD_SHIPPING_STATUS };
}
exports.UpdateShippingRequest = {
    fromJSON(object) {
        const message = {
            cardId: isSet(object.cardId) ? globalThis.String(object.cardId) : '',
            status: isSet(object.status)
                ? (0, card_details_1.cardShippingStatusFromJSON)(object.status)
                : card_details_1.CardShippingStatus.INVALID_CARD_SHIPPING_STATUS,
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.cardId !== '') {
            obj.cardId = message.cardId;
        }
        if (message.status !== card_details_1.CardShippingStatus.INVALID_CARD_SHIPPING_STATUS) {
            obj.status = (0, card_details_1.cardShippingStatusToJSON)(message.status);
        }
        return obj;
    },
    create(base) {
        return exports.UpdateShippingRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseUpdateShippingRequest();
        message.cardId = object.cardId ?? '';
        message.status = object.status ?? card_details_1.CardShippingStatus.INVALID_CARD_SHIPPING_STATUS;
        return message;
    },
};
function createBaseUpdateShippingResponse() {
    return { card: undefined };
}
exports.UpdateShippingResponse = {
    fromJSON(object) {
        const message = {};
        if (isSet(object.card)) {
            message.card = issuer_card_1.IssuerCard.fromJSON(object.card);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.card !== undefined) {
            obj.card = issuer_card_1.IssuerCard.toJSON(message.card);
        }
        return obj;
    },
    create(base) {
        return exports.UpdateShippingResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseUpdateShippingResponse();
        message.card = (object.card !== undefined && object.card !== null)
            ? issuer_card_1.IssuerCard.fromPartial(object.card)
            : undefined;
        return message;
    },
};
function createBaseUpdateExpirationDateRequest() {
    return { cardId: '', expirationDate: date_1.ExpirationDate.fromPartial({}) };
}
exports.UpdateExpirationDateRequest = {
    fromJSON(object) {
        const message = {
            cardId: isSet(object.cardId) ? globalThis.String(object.cardId) : '',
            expirationDate: isSet(object.expirationDate)
                ? date_1.ExpirationDate.fromJSON(object.expirationDate)
                : date_1.ExpirationDate.fromPartial({}),
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.cardId !== '') {
            obj.cardId = message.cardId;
        }
        if (message.expirationDate !== undefined) {
            obj.expirationDate = date_1.ExpirationDate.toJSON(message.expirationDate);
        }
        return obj;
    },
    create(base) {
        return exports.UpdateExpirationDateRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseUpdateExpirationDateRequest();
        message.cardId = object.cardId ?? '';
        message.expirationDate = (object.expirationDate !== undefined && object.expirationDate !== null)
            ? date_1.ExpirationDate.fromPartial(object.expirationDate)
            : date_1.ExpirationDate.fromPartial({});
        return message;
    },
};
function createBaseUpdateExpirationDateResponse() {
    return { card: undefined };
}
exports.UpdateExpirationDateResponse = {
    fromJSON(object) {
        const message = {};
        if (isSet(object.card)) {
            message.card = issuer_card_1.IssuerCard.fromJSON(object.card);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.card !== undefined) {
            obj.card = issuer_card_1.IssuerCard.toJSON(message.card);
        }
        return obj;
    },
    create(base) {
        return exports.UpdateExpirationDateResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseUpdateExpirationDateResponse();
        message.card = (object.card !== undefined && object.card !== null)
            ? issuer_card_1.IssuerCard.fromPartial(object.card)
            : undefined;
        return message;
    },
};
/**
 * Card Test API Service
 */
class CardTestApiServiceClient {
    rpc;
    name = 'com.step.testapi.card.proto.CardTestApiService';
    type = rpc_1.ServiceType.UNAUTHENTICATED;
    path = '/test';
    methods = [{
            name: 'UpdateShipping',
            requestType: exports.UpdateShippingRequest,
            responseType: exports.UpdateShippingResponse,
            authenticationOptions: undefined,
        }, {
            name: 'UpdateExpirationDate',
            requestType: exports.UpdateExpirationDateRequest,
            responseType: exports.UpdateExpirationDateResponse,
            authenticationOptions: undefined,
        }];
    constructor(rpc) {
        this.rpc = rpc;
    }
    /**
     * Updates card shipping status.
     */
    updateShipping(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[0],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
    /**
     * Updates card expiration date.
     */
    updateExpirationDate(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[1],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
}
exports.CardTestApiServiceClient = CardTestApiServiceClient;
function isSet(value) {
    return value !== null && value !== undefined;
}
//# sourceMappingURL=card-testapi-service.js.map